var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLogoutBoxFill = function SvgLogoutBoxFill(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 25 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M6.2 3h12.6a.9.9 0 0 1 .9.9v16.2a.9.9 0 0 1-.9.9H6.2a.9.9 0 0 1-.9-.9V3.9a.9.9 0 0 1 .9-.9m3.6 8.1V8.4L5.3 12l4.5 3.6v-2.7h5.4v-1.8z"
  })));
};
export default SvgLogoutBoxFill;